import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AssociationSelect from 'components/AssociationSelect'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { selectUserGroups } from 'workspace/selectors'
import { changeFormData } from 'workspace/actions'

const WorkspaceFormUserGroup = ({ id, userGroups, onChange, disabled }) => (
  <WorkspaceFormInput attribute='userGroup'>
    <AssociationSelect
      isClearable={false}
      options={userGroups}
      value={id}
      onChange={newId => onChange({ userGroupId: newId })}
      isDisabled={disabled}
      backspaceRemovesValue={false}
    />
  </WorkspaceFormInput>
)

WorkspaceFormUserGroup.propTypes = {
  userGroups: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, id: PropTypes.number })),
  id: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

const mapStateToProps = state => ({
  userGroups: selectUserGroups(state),
  id: state.form.data.userGroupId
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormUserGroup)
